module.exports = __webpack_public_path__ + "static/eit-fan-2026-paris-cohort-2a67da26596d51f18d122f8fded31244.png";